import getURLSearchParam from './url'

export function queryObj(debugQueryStr: string) {
  let debugObj = {}
  if (debugQueryStr) {
    const debugArr = decodeURIComponent(debugQueryStr)
      .split(',')
      .filter((k) => k)
    if (debugArr && debugArr.length > 0) {
      debugObj = debugArr.reduce((prev: { [key: string]: boolean }, key) => {
        prev[key] = true
        return prev
      }, {})
    }
    // console.log('[debug]', debugObj)
  }
  return debugObj
}

const debug: Record<string, string> = (function () {
  return queryObj(getURLSearchParam('_debug_'))
})()

export default debug
